import { useEffect, useRef, MutableRefObject, FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

const modalRoot = document.getElementById('modal');

type ModalProps = {
  maxWidth?: string;
  minHeight?: string;
  className?: string;
  children: ReactNode;
};

const Modal: FC<ModalProps> = ({
  maxWidth,
  minHeight,
  className,
  children,
}) => {
  const elRef: MutableRefObject<HTMLDivElement | null> = useRef(null);

  if (!elRef.current) {
    elRef.current = document.createElement('div');
  }

  useEffect(() => {
    if (!modalRoot || !elRef.current) {
      return;
    }

    if (className) {
      const classes = className.split(' ');
      classes.map((i) => elRef.current?.classList.add(i));
      elRef.current?.classList.add('relative');
    } else {
      const defaultStyles =
        'w-full absolute top-32 left-1/2 transform -translate-x-1/2'.split(' ');
      defaultStyles.map((i) => elRef.current?.classList.add(i));
      if (maxWidth) {
        elRef.current.classList.add(maxWidth);
      } else {
        elRef.current.classList.add('max-w-3xl');
      }

      if (minHeight) {
        elRef.current.style.minHeight = minHeight;
      } else {
        elRef.current.classList.add('bottom-32');
        elRef.current.style.minHeight = '480px';
      }
    }

    modalRoot.appendChild(elRef.current);

    return () => {
      if (elRef.current) {
        modalRoot.removeChild(elRef.current);
      }
    };
  }, [maxWidth, minHeight]);

  return createPortal(<>{children}</>, elRef.current);
};

export default Modal;
